module.exports = {"511823100":"富林镇","511823101":"九襄镇","511823102":"乌斯河镇","511823103":"宜东镇","511823104":"富庄镇","511823105":"清溪镇","511823106":"大树镇","511823107":"皇木镇","511823108":"唐家镇","511823109":"富泉镇","511823110":"安乐镇","511823111":"前域镇","511823209":"富乡乡","511823220":"马烈乡","511823224":"河南乡","511823225":"晒经乡","511823227":"小堡藏族彝族乡","511823228":"片马彝族乡","511823229":"坭美彝族乡","511823230":"永利彝族乡","511823231":"顺河彝族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511823.json
// module id = 2514
// module chunks = 0